import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate  } from '@angular/router';
import { AuthGuard } from './services/auth/auth.guard';
import { LoginComponent } from './ui/login/login.component';
import { MainComponent } from './ui/main/main.component';


const routes: Routes = [
  { path: '', redirectTo: '/login',  pathMatch: 'full'},
  { path: 'login', component: LoginComponent},
  { path: 'main', component: MainComponent , canActivate:[AuthGuard] },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
